import { createSelector } from 'reselect'

import { getSalesEventTypes } from 'store/SalesEventTypes/selectors'

export const getSalesEvents = (state) =>
  Object.values(state?.salesEvents?.byId ?? {})

export const getSalesEventsWithEventType = createSelector(
  getSalesEventTypes,
  getSalesEvents,
  (salesEventTypes, salesEvents) => {
    return salesEvents.map((salesEvent) => {
      const salesEventTypeName = salesEventTypes.find(
        (salesEventType) =>
          salesEventType.uuid === salesEvent.salesEventTypeId
      )
      return {
        ...salesEvent,
        salesEventTypeName: salesEventTypeName?.name ?? '',
      }
    })
  }
)

export const getSalesEvent = (state, uuid) =>
  state?.salesEvents?.byId[uuid] ?? {}

export const getIsSalesEventsLoading = (state) =>
  state?.salesEvents?.isLoading ?? false

export const getSearchSalesEventsValue = (state) =>
  state?.salesEvents?.filters?.searchSalesEventsValue ?? ''
